// table-body — default skin module (RUN-407: native table redesign)
// Configuration node; host is hidden. run-table renders <tbody> directly.

export const styles = `
  :host {
    display: none;
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<slot></slot>`;
}
